export default __webpack_public_path__ + "static/program-circle-rental-en-e51ab14514fcdb6bdf1ecb0088f8011e.svg";